<atn-ds-page class="atn-dms-graph-page">
  <atn-ds-page-header
    [name]="'Schema Graph'"
    pageHeader
  />
  <atn-dms-schema-graph />
</atn-ds-page>
